/**
 * Explore Component
 *
 * Showcases different coffee types and varieties.
 * Features:
 * - Three-column layout: Left items, Center image, Right items
 * - Parallax effect on center image using Locomotive Scroll
 * - Responsive: Stacks vertically on mobile, horizontal on desktop
 * - Each side displays 2 coffee type items
 */

import { Image } from "@heroui/image";

import ExploreItem from "./ExploreItem";

const Explore = () => {
  return (
    <section className="py-12 xl:py-0 xl:h-[90vh] xl:w-screen" id="benefits">
      <div className="container mx-auto xl:w-full xl:h-full flex xl:justify-center xl:items-center">
        {/* Three-column layout: Left | Center | Right */}
        <div className="w-full flex flex-col lg:flex-row gap-12 xl:gap-20">
          {/* Left Column - First 2 items, right-aligned on desktop */}
          <div className="flex-1 flex flex-col justify-around items-end text-center xl:text-left gap-12 xl:gap-0 max-w-100 mx-auto xl:max-w-none xl:mx-0">
            {/* Item 1: Masterfully Roasted Espresso */}
            <ExploreItem
              icon="coffee-1.svg"
              itemCSS="xl:text-right xl:items-end" // Right-align on desktop
              text={{
                title: "Masterfully Roasted Espresso",
                description:
                  "Bold, complex profiles balanced for the perfect extraction. Our signature blend featuring chocolate and citric notes.",
              }}
            />
            {/* Item 2: Artisanal Pour-Overs */}
            <ExploreItem
              icon="coffee-2.svg"
              itemCSS="xl:text-right xl:items-end"
              text={{
                title: "Artisanal Pour-Overs",
                description:
                  "Highlighting the unique terroir of single-origin beans. A clean, sophisticated cup for the true coffee purist.",
              }}
            />
          </div>

          {/* Center Column - Coffee cup image with parallax effect (desktop only) */}
          <div className="hidden xl:flex justify-center">
            <div className="relative w-80.5 h-145">
              <Image
                alt="image"
                className="object-cover w-full h-full"
                src="/assets/explore/cup.png"
              />
            </div>
          </div>
          {/* Right Column - Last 2 items, left-aligned on desktop */}
          <div className="flex-1  flex flex-col justify-around text-center xl:text-left gap-12 xl:gap-0 max-w-100 mx-auto xl:max-w-none xl:mx-0">
            {/* Item 3: Nitro & Craft Cold Brews */}
            <ExploreItem
              icon="coffee-3.svg"
              itemCSS="xl:text-left items-start" // Left-align on desktop
              text={{
                title: "Nitro & Craft Cold Brews",
                description:
                  "Steeped for 18 hours for a velvety-smooth finish with zero bitterness. Refreshment in its most refined form.",
              }}
            />
            {/* Item 4: Botanical Lattes */}
            <ExploreItem
              icon="coffee-4.svg"
              itemCSS="xl:text-left items-start"
              text={{
                title: "Botanical Lattes",
                description:
                  "Signature infusions where high-grade espresso meets natural botanicals. Delicate, creamy, and distinctively Zenbrew.",
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Explore;
